<sf-notification></sf-notification>

<div class="formgrid grid text-lg dashboard">

    <div class="surface-section col-12 ">
         <div class="flex flex-column lg:flex-row gap-3 justify-content-between lg:align-items-center border-primary p-3 w-full" style="border-top: 7px solid;">
            <div class="flex flex-column gap-2 col-12 md:col-12 lg:col-3">
                <div class="flex align-items-center gap-2">
                    <h1 class="m-0 font-semibold text-900 text-3xl line-height-3">Painel de Atendimento</h1>
                </div>
                <p class="mb-0 mt-0 text-base text-600 text-lg">Acompanhe seus pedidos e indicadores de atendimento.</p>
            </div>
            <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-2">
                <div class="shadow-2 surface-card p-4 border-2 border-transparent cursor-pointer" style="border-radius: 10px" (click)="newService()">
                    <div class="flex align-items-center mb-2">
                        <div class="mr-3">
                            <span class="inline-flex justify-content-center align-items-center bg-green-100" style="border-radius: 4px; width:45px; height: 45px">
                                <i class="pi pi-users text-2xl text-green-600" style="font-size: 1.5rem"></i>
                            </span>
                        </div>
                        <span class="text-900 text-2xl mb-1 font-bold">Clientes</span>
                    </div>
                    <div class="inline-flex justify-content-between mb-5">
                        <div class="justify-content-center mr-5">
                            <span class="block text-blue-500 font-bold mb-1 text-6xl">{{kpiMonthClient}}</span>
                            <span class="text-500 font-medium">Ativos</span>
                        </div>
                    </div>
                    <div class="inline-flex justify-content-between">
                        <div class="block justify-content-center">
                            <span class="block text-blue-500 font-bold mb-1 text-6xl">{{kpiMonthClient}}</span>
                            <span class="block text-500 font-medium">Últimos 30 dias</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3">
                <div class="shadow-2 surface-card p-4 border-2 border-transparent cursor-pointer" style="border-radius: 10px" (click)="myServices()">
                    <div class="flex align-items-center mb-2">
                        <div class="mr-3">
                            <span class="inline-flex justify-content-center align-items-center bg-blue-100" style="border-radius: 4px; width:45px; height: 45px">
                                <i class="pi pi-file-edit text-2xl text-blue-600" style="font-size: 1.5rem"></i>
                            </span>
                        </div>
                        <span class="text-900 text-2xl mb-1 font-bold">Encerramentos no Mês</span>
                    </div>
                    <div class=" flex justify-content-center">
                        <p-knob [(ngModel)]="kpiMonthClosed" valueColor="SlateGray" rangeColor="MediumTurquoise"  strokeWidth="15" size="100" valueTemplate="{value}%" />
                    </div>
                </div>
            </div>
            <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3">
                <div class="shadow-2 surface-card p-4 border-2 border-transparent cursor-pointer" style="border-radius: 10px" (click)="myServices()">
                    <div class="flex align-items-center mb-2">
                        <div class="mr-3">
                            <span class="inline-flex justify-content-center align-items-center bg-blue-100" style="border-radius: 4px; width:45px; height: 45px">
                                <i class="pi pi-file-edit text-2xl text-blue-600" style="font-size: 1.5rem"></i>
                            </span>
                        </div>
                        <span class="text-900 text-2xl mb-1 font-bold">Taxa de Conversão</span>
                    </div>
                    <div class="flex justify-content-center">
                        <p-knob [(ngModel)]="kpiMonthConversion" valueColor="SlateGray" rangeColor="MediumTurquoise"  strokeWidth="15" size="100" valueTemplate="{value}%" />
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="col-12 md:col-12 lg:col-6 xl:col-6 mt-2">
        <div class="surface-card shadow-2 border-round p-4">
            <div class="flex justify-content-between align-items-center mb-5 w-full">
                <span class="text-xl">Pedidos Aguardando Atendimento</span>
            </div>
            <p-scrollPanel [style]="{ width: '100%', height: screenHeightOrder }">
                <ul class="list-none p-0 m-0">
                    <ng-container *ngFor="let order of orderListAttendant; let i = index">
                        <a pRipple class="cursor-pointer" [routerLink]="['/order/detail/', order.id]">
                            <li class="flex flex-column md:flex-row md:align-items-center md:justify-content-between p-3 border-1 mb-3 bg-{{order.classColor}}-50 border-{{order.classColor}}-500"
                                style="border-radius: 10px;">
                                <div>
                                    <div>
                                        <span class="inline-flex justify-content-center align-items-center w-2rem h-2rem border-circle border-1 border-{{order.classColor}}-200">
                                            <i class="pi pi-user text-{{order.classColor}}-600"></i>
                                        </span>
                                        <span class="text-{{order.classColor}}-700 text-xl ml-2">{{order.clientName}} - {{order.clientPhone}}</span>
                                        <p-rating [(ngModel)]="order.clientRating" [readonly]="true" [cancel]="false" class="ml-3"></p-rating>
                                    </div>
                                    <p class="text-{{order.classColor}}-700 mt-2 mb-0 font-bold">Pedido: #{{order.code}}
                                        <span class="font-bold">{{order.description}}</span></p>
                                    <p class="text-{{order.classColor}}-700 mt-2 mb-0">Data: <span
                                            class="font-medium">{{order.statusDate | date: 'dd/MM/yyyy'}}</span></p>
                                </div>
                                <div
                                    class="flex align-items-center justify-content-between md:justify-content-end mt-3 md:mt-0">
                                    <div class="text-right ml-3">
                                        <p class="bg-{{order.classColor}}-300 text-{{order.classColor}}-900 font-bold text-sm py-1 px-2" style="border-radius: 10px">{{order.statusName}}</p>
                                        <p class="text-{{order.classColor}}-700 font-bold text-2xl mb-3">{{order.totalValue | currency: 'BRL'}}</p>
                                        <p class="text-{{order.classColor}}-700 mt-2 mb-0">obs: <span class="font-medium">{{order.obs}}</span></p>
                                    </div>
                                </div>
                            </li>
                        </a>
                    </ng-container>
                </ul>
            </p-scrollPanel>
        </div>
    </div>

    <div class="col-12 md:col-12 lg:col-6 xl:col-6 mt-2">
        <div class="surface-card shadow-2 border-round p-4">
            <div class="flex justify-content-between align-items-center mb-5 w-full">
                   <span class="text-xl">Pedidos com Ressalvas - Clientes, Processamento ou Pendências</span>
            </div>
            <p-scrollPanel [style]="{ width: '100%', height: screenHeightOrder }">
                <ul class="list-none p-0 m-0">
                    <ng-container *ngFor="let order of orderListClient; let i = index">
                        <a pRipple class="cursor-pointer" [routerLink]="['/order/detail/', order.id]">
                            <li class="flex flex-column md:flex-row md:align-items-center md:justify-content-between p-3 border-1 mb-3 bg-{{order.classColor}}-50 border-{{order.classColor}}-500"
                                style="border-radius: 10px;">
                                <div>
                                    <div>
                                        <span class="inline-flex justify-content-center align-items-center w-2rem h-2rem border-circle border-1 border-{{order.classColor}}-200">
                                            <i class="pi pi-user text-{{order.classColor}}-600"></i>
                                        </span>
                                        <span class="text-{{order.classColor}}-700 text-xl ml-2">{{order.clientName}} - {{order.clientPhone}}</span>
                                        <p-rating [(ngModel)]="order.clientRating" [readonly]="true" [cancel]="false" class="ml-3"></p-rating>
                                    </div>
                                    <p class="text-{{order.classColor}}-700 mt-2 mb-0 font-bold">Pedido: #{{order.code}} <span class="font-bold">{{order.description}}</span></p>
                                    <p class="text-{{order.classColor}}-700 mt-2 mb-0">Data: <span class="font-medium">{{order.statusDate | date: 'dd/MM/yyyy hh:mm'}}</span></p>
                                </div>
                                <div
                                    class="flex align-items-center justify-content-between md:justify-content-end mt-3 md:mt-0">
                                    <div class="text-right ml-3">
                                        <p class="bg-{{order.classColor}}-300 text-{{order.classColor}}-900 font-bold text-sm py-1 px-2" style="border-radius: 10px">{{order.statusName}}</p>
                                        <p class="text-{{order.classColor}}-700 font-bold text-2xl mb-3">{{order.totalValue | currency: 'BRL'}}</p>
                                        <p class="text-{{order.classColor}}-700 mt-2 mb-0">obs: <span class="font-medium">{{order.obs}}</span></p>
                                    </div>
                                </div>
                            </li>
                        </a>
                    </ng-container>
                </ul>
            </p-scrollPanel>
        </div>
    </div>

    <div class="col-12 md:col-12 lg:col-6 xl:col-6 mt-2">

        <p-card styleClass="chat" [style]="{'height': '100%'}" header="Menssagens e Notificações">
            <p-scrollPanel [style]="{ width: '100%', height: screenHeightChat }">
                <!-- <ng-container *ngFor="let chat of chatList; let i = index">
                        <ul>
                            <div *ngIf="chat.sourceUserId != userId">
                                <li class="message-from">
                                    <div class="message-meta">
                                        <p-avatar [label]="getInitials(chat.sourceUserName)"
                                            [style]="{ 'background-color': AVATAR_COLOR_FROM, 'color': 'white', 'font-weight': 'bold' }"></p-avatar>
                                        <span class="name ml-2">{{chat.sourceUserName}}</span>
                                        <span class="time">{{chat.dateOfRegistration | date: 'dd/MM/yyyy HH:mm'}}</span>

                                        <button pButton pRipple icon="pi pi-comment"
                                            class="text-xl font-semibold btn-action mt-2" size="large" style="font-size: 10px !important;"
                                            [label]="'message.new_message' | translate" (click)="openDialogSendMessage(chat.woOrderId);">
                                        </button>
                                    </div>
                                    <div class="message">
                                        <span><label [innerHtml]="chat.message"></label></span>
                                    </div>
                                </li>
                            </div>
                            <div *ngIf="chat.sourceUserId == userId">
                                <li class="message-own">
                                    <div class="message">
                                        <span><label [innerHtml]="chat.message"></label></span>
                                    </div>
                                    <div class="message-meta">
                                        <p-avatar [label]="getInitials(chat.sourceUserName)"
                                            [style]="{ 'background-color': AVATAR_COLOR_OWN, 'color': 'white', 'font-weight': 'bold' }"></p-avatar>
                                        <span class="name ml-2">{{chat.sourceUserName}}</span>
                                        <span class="time">{{chat.dateOfRegistration | date: 'dd/MM/yyyy HH:mm'}}</span>
                                    </div>
                                </li>
                            </div>
                        </ul>
                    </ng-container> -->
                <app-sc-user-message-chat></app-sc-user-message-chat>
            </p-scrollPanel>
            <!-- <div class="write-message">
                        <i class="pi pi-paperclip"></i>
                        <input type="text" />
                    </div> -->

        </p-card>
    </div>

    <div class="col-12 md:col-12 lg:col-6 xl:col-6 mt-2" >
        <p-card styleClass="chat" header="Quantidade por Tipo de Serviço">
            <p-chart type="bar" [data]="chartData" [options]="chartOptions" />
        </p-card>
    </div>


